import React, { useState, useEffect, useCallback } from "react";
import { FaSearch } from "react-icons/fa";
import { RiFilterOffLine, RiFilterLine } from "react-icons/ri";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";
import { ButtonGroup, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import _ from "lodash";
import TextInputFormik from "../../../components/UI/TextInput/TextInputFormik";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import ButtonImagePermission from "../../../components/UI/Button/ButtonImagePermission";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import SelectInputCachedFormik from "../../../components/UI/SelectInput/SelectInputCachedFormik";
import ChipList from "../../../components/UI/ChipList/ChipList";
import constants from "../../Constants";

const CarregandoView = (
  <span>
    <Spinner animation="border" role="status" /> Carregando ...
  </span>
);

const removeCell = (row, setShowDesassociarConfirm, nomeModelo) => (
  <ButtonImagePermission
    permission={funcionalidades.modeloImportacao.deletar}
    className="btn-lg text-danger pa-0 p-0"
    onClick={() =>
      setShowDesassociarConfirm({
        show: true,
        body: `Deseja remover a Ocorrencia Nº ${row.sequenceTipoOcorrencia} do modelo ${nomeModelo}?`,
        context: row.sequenceTipoOcorrencia,
      })
    }
    buttonImage={<MdClose />}
    tooltipImage="Remover ocorrência"
  />
);

const ListaOcorrencias = ({
  field,
  sequencialModelo,
  ocorrenciasRelacionadas,
  nomeModelo,
  formik,
  history,
  toggledClearRows,
}) => {
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [inputSearchArgument, setInputSearchArgument] = useState("");
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [searchParameters, setSearchParameters] = useState({});

  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showDesassociarConfirm, setShowDesassociarConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  const updateFormik = (selectedItem) => {
    // Somente adiciona novos itens... os chips removem
    if (!formik.values[field]?.length) {
      formik.setFieldValue(field, [selectedItem]);
    } else if (
      !_.find(
        formik.values[field],
        (selected) => selectedItem.sequenceTipoOcorrencia === selected.sequenceTipoOcorrencia,
      )
    ) {
      formik.setFieldValue(field, [...formik.values[field], selectedItem]);
    }
  };

  const removeItem = (itemRemoved) => {
    const itemRemovedIndex = formik.values[field].findIndex(
      (item) => item.sequenceTipoOcorrencia === itemRemoved.sequenceTipoOcorrencia,
    );
    formik.values[field].splice(itemRemovedIndex, 1);
    formik.setFieldValue(field, [...formik.values[field]]);
    setRows((curr) => [...curr]);
  };

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback(() => {
    setPageSize(25);
    setPageNumber(1);
  }, []);

  const columnsRelacionadas = [
    {
      name: "Ações",
      selector: "",
      maxWidth: "15px",
      center: true,
      cell: (row) => removeCell(row, setShowDesassociarConfirm, nomeModelo),
    },
    {
      name: "Nº Ocorrência",
      selector: "sequenceTipoOcorrencia",
      width: "200px",
      center: true,
      sortable: true,
    },
    {
      name: "Descrição",
      selector: "descricaoTipoOcorrencia",
      sortable: true,
      maxWidth: "1000px",
    },
  ];

  const columnsNaoRelacionadas = [
    {
      width: "40px",
      center: true,
      sortable: true,
      cell: (row) => {
        if (formik.values[field]?.length) {
          if (_.find(formik.values[field], (item) => item.sequenceTipoOcorrencia === row.sequenceTipoOcorrencia)) {
            return `☑`;
          }
        }
        return `☐`;
      },
    },
    {
      name: "Nº Ocorrência",
      selector: "sequenceTipoOcorrencia",
      width: "200px",
      center: true,
      sortable: true,
    },
    {
      name: "Descrição",
      selector: "descricaoTipoOcorrencia",
      sortable: true,
    },
  ];

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      toast.success("Ocorrência desassociada com sucesso.");
      document.location.reload(true);
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors);
    }

    setShowDesassociarConfirm({ show: false });
  }, [deleteItemData, deleteItemErrors, setShowDesassociarConfirm, sequencialModelo, history]);

  const {
    request: requestConsultaOcorrencia,
    data: dataConsultaOcorrencia,
    errors: errorConsultaOcorrencia,
    isLoading: isLoadingOcorrencia,
  } = useApiClient();

  useEffect(() => {
    requestConsultaOcorrencia(apiRoutes.fiscalizacao.parametrizacao.consultaOcorrenciasGeral, {
      ...searchParameters,
      pageSize,
      pageNumber,
    });
  }, [requestConsultaOcorrencia, searchParameters, pageSize, pageNumber]);

  useEffect(() => {
    if (dataConsultaOcorrencia && dataConsultaOcorrencia.result) {
      setRows(
        dataConsultaOcorrencia.result.filter((row) => row.sequenceModelo !== sequencialModelo && !row.sequenceModelo) ||
          [],
      );
      setTotalRows(
        dataConsultaOcorrencia.result.filter((row) => row.sequenceModelo !== sequencialModelo && !row.sequenceModelo)
          .length
          ? dataConsultaOcorrencia.result[0].length
          : 0,
      );
    }

    if (errorConsultaOcorrencia) {
      toast.error(errorConsultaOcorrencia.message);
    }
  }, [dataConsultaOcorrencia, errorConsultaOcorrencia, sequencialModelo]);

  return (
    <>
      <EfisModal
        show={showDesassociarConfirm.show}
        body={showDesassociarConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowDesassociarConfirm({ show: false })}
        confirmationHandler={() => {
          const params = { sqTipoOcorrencia: showDesassociarConfirm.context };
          deleteItemRequest(apiRoutes.fiscalizacao.parametrizacao.desassociarOcorrenciaModeloImportacao, params);
        }}
      />
      {ocorrenciasRelacionadas ? (
        <div className="row">
          <div className="col-lg-12">
            <div className="card shadow mb-4">
              <div className="card-header pt-3 pb-0 flex-row w-100">
                <h6 className="m-0 font-weight-bold text-primary flex-grow-1 py-3">Ocorrências Relacionadas</h6>
              </div>

              <div className="card-body">
                <DataTable
                  noHeader
                  keyField="id"
                  columns={columnsRelacionadas}
                  data={ocorrenciasRelacionadas}
                  progressPending={isLoadingOcorrencia}
                  noDataComponent="Nenhum registro para exibir"
                  progressComponent={CarregandoView}
                  defaultSortFieldId={1}
                  sortIcon={<BsArrowDown />}
                  pagination
                  sortable
                  pointerOnHover
                  paginationComponentOptions={constants.paginationComponentOptions}
                  paginationPerPage={25}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header pt-3 pb-0 flex-row w-100">
              <Form.Group as={Row} className="d-flex flex-row">
                {<h6 className="font-weight-bold text-primary flex-grow-1 ml-2 mt-2">Ocorrências Não Relacionadas</h6>}

                {!showAdvancedSearch && (
                  <ButtonGroup>
                    <Form.Control
                      className="w-auto border-top-right-0 border-bottom-right-0"
                      type="text"
                      placeholder="Nº Ocorrência"
                      value={inputSearchArgument}
                      onChange={(e) => setInputSearchArgument(e.target.value)}
                    />

                    <Button
                      className="btn-search-inside btn-md mr-3"
                      onClick={() => {
                        setPageNumber(1);
                        setSearchParameters({ searchArgument: inputSearchArgument });
                      }}
                    >
                      <FaSearch />
                    </Button>
                  </ButtonGroup>
                )}

                {formik && (
                  <Button
                    className="btn btn-primary btn-md mr-2"
                    tootip="Busca Avançada"
                    onClick={() =>
                      setShowAdvancedSearch((curr) => {
                        formik.resetForm();
                        return !curr;
                      })
                    }
                  >
                    {showAdvancedSearch ? <RiFilterOffLine /> : <RiFilterLine />}
                  </Button>
                )}
              </Form.Group>

              {showAdvancedSearch && (
                <>
                  <hr />
                  <Row>
                    <Form.Group as={Col} sm={12} md={4}>
                      <Form.Label>Tipo Detalhamento</Form.Label>
                      <SelectInputCachedFormik formik={formik} field="tipoDetalhamento" tipoItem="tipoDetalhamento" />
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={4}>
                      <Form.Label>Nº Ocorrencia</Form.Label>
                      <TextInputFormik formik={formik} field="sequenceTipoOcorrencia" />
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={4}>
                      <Form.Label>Descricao</Form.Label>
                      <TextInputFormik formik={formik} field="descricaoTipoOcorrencia" />
                    </Form.Group>
                  </Row>
                  <Form.Group as={Row} className="d-flex flex-row">
                    <Col sm="12">
                      <Button
                        className="btn btn-primary btn-md mr-2"
                        onClick={() => {
                          setPageNumber(1);
                          setSearchParameters({ ...formik.values });
                        }}
                      >
                        Buscar
                      </Button>
                    </Col>
                  </Form.Group>
                </>
              )}
              <ChipList items={formik.values[field]} field="sequenceTipoOcorrencia" onRemove={removeItem} />
              <Form.Label className="small">Total selecionado: {formik.values[field]?.length ?? 0}</Form.Label>
              <br />
              <Form.Label className="text-danger small">{formik.errors[field] ? formik.errors[field] : ""}</Form.Label>
            </div>

            <div className="card-body">
              <DataTable
                noHeader
                title="Ocorrências não relacionadas"
                keyField="id"
                columns={columnsNaoRelacionadas}
                data={rows}
                progressPending={isLoadingOcorrencia}
                noDataComponent="Nenhum registro para exibir"
                progressComponent={CarregandoView}
                defaultSortFieldId={1}
                sortIcon={<BsArrowDown />}
                pagination
                sortable
                onRowClicked={(row) =>
                  _.find(formik.values[field], (item) => item.sequenceTipoOcorrencia === row.sequenceTipoOcorrencia)
                    ? removeItem(row)
                    : updateFormik(row)
                }
                pointerOnHover
                paginationComponentOptions={constants.paginationComponentOptions}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationTotalRows={totalRows}
                paginationPerPage={25}
                clearSelectedRows={toggledClearRows}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListaOcorrencias;
